module.exports = __webpack_public_path__ + "static/media/CloseIcon.1231d26c.svg";